import { BaseDto } from "../base/baseDto.model";

export class PersonaPropietarioDto extends BaseDto{
    public nroDocumento: string = "";
    public id_Propietario: number = 0;
    public titular: boolean = false;
}
